import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
// import { getProfile } from '../../reducer/profileSlice';
import { getMonitorTimelineWeek } from '../../reducer/monitorPageSlice';
import { getAreaLevel } from '../../reducer/areaLevelSlice';
import { Button, IconButton, LinearProgress, Tooltip, Typography, styled } from '@mui/material';
import { DataGridPro, GridToolbarContainer, GridToolbarQuickFilter, useGridApiRef } from '@mui/x-data-grid-pro';
import { getAmphurDataMap, getProvinceDataMap, getRegionDataMap, getTambonDataMap } from '../../reducer/areaDataSlice';
import { getAreaSelected } from '../../reducer/areaSelectedSlice';
import InfoIcon from '@mui/icons-material/Info';
import DengueEOCLegeng from '../legend/DengueEOCLegeng';



import dayjs from 'dayjs';
import buddhistEra from "dayjs/plugin/buddhistEra";
import advancedFormat from "dayjs/plugin/advancedFormat"

import 'dayjs/locale/th';
import { getIAAM } from '../../reducer/iaamSlice';
import { getWeekOfYear } from '../../reducer/weekOfYearSlice';
import EOCDetailDialog from './EOCDetailDialog';
dayjs.extend(buddhistEra);
dayjs.extend(advancedFormat)
dayjs.locale("th");

dayjs.updateLocale('th', {
    weekStart: 0,
    yearStart: 7
})

const autoSizeOptions = {
    // columns: ['value', 'result'],
    includeOutliers: true,
    includeHeaders: true,
    expand: true
}
const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
    border: 0,
    borderRadius: 0,
    color:
        theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.85)',
    WebkitFontSmoothing: 'auto',
    letterSpacing: 'normal',
    '& .MuiDataGrid-columnsContainer': {
        backgroundColor: theme.palette.mode === 'light' ? '#fafafa' : '#1d1d1d',
    },
    '& .MuiDataGrid-iconSeparator': {
        // display: 'none',
    },
    '& .MuiDataGrid-columnHeaders': {
        borderTop: `1px solid ${theme.palette.mode === 'light' ? 'rgba(224, 224, 224, 1)' : '#303030'}`
    },
    '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
        borderRight: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'}`,
    },
    '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
        borderBottom: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'}`,
    },
    '& .MuiDataGrid-cell': {
        color: theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.65)',
    },
    '& .MuiPaginationItem-root': {
        borderRadius: 0,
    },
    '& .eoc_qualify': {
        backgroundColor: '#1150A4',
        '&:hover': {
            backgroundColor: '#2f5b97'
        }
    },
    '& .week_cell': {
        padding: '0 0',
    }
    // ...customCheckbox(theme),
}));

const isBetweenOpenEOC = (eoc_open_list, week, year) => {
    let is_open = {}
    for (const idx in eoc_open_list) {
        let eoc_open = eoc_open_list[idx];
        const start_eoc = dayjs().year(eoc_open.eoc_open_year).week(eoc_open.eoc_open_week)
        const end_eoc = eoc_open?.closed_eoc_week ? dayjs().year(eoc_open.closed_eoc_year).week(eoc_open.closed_eoc_week) : dayjs()
        if (end_eoc >= dayjs().year(year).week(week) && dayjs().year(year).week(week) >= start_eoc) {
            is_open['status'] = true
            is_open['eocData'] = eoc_open
            break
        }
    }

    return is_open
}

const getWoEoc = (wo_eoc_list, week, year) => {
    let count = 0
    for (const idx in wo_eoc_list) {
        let wo_eoc = wo_eoc_list[idx];
        if (wo_eoc.ep_year === year && wo_eoc.ep_week === week) {
            count += 1
        }
    }

    return count
}


function MonitorTimeline(props) {
    const iaam = useSelector(getIAAM);
    const [isLoading, setIsLoading] = useState(false)
    const weeklist = useSelector(getMonitorTimelineWeek);
    const areaLevel = useSelector(getAreaLevel);
    const areaSelected = useSelector(getAreaSelected);
    const [columns, setColumns] = useState([]);
    const [pinColumns, setPinColumns] = useState([]);
    const [columnGrouping, setColumnGrouping] = useState([]);
    const refTable = useGridApiRef();
    const [dataTable, setDataTable] = useState([]);
    const [dataTableShow, setDataTableShow] = useState([]);
    const regionMap = useSelector(getRegionDataMap);
    const provinceMap = useSelector(getProvinceDataMap);
    const amphurMap = useSelector(getAmphurDataMap);
    const tambonMap = useSelector(getTambonDataMap);
    const woy = useSelector(getWeekOfYear);

    const [eocId, setEOCId] = useState(undefined);
    const [openDialog, setOpenDialog] = useState(false);

    const [coordinates, setCoordinates] = useState({
        rowIndex: 0,
        colIndex: 0,
    });

    const [openLegend, setOpenLegend] = useState(false)
    const [eocLevel, setEOCLevel] = useState("01")

    const handleEOCDetailOpen = (e) => {

        setEOCId(e.target.value)
        setOpenDialog(true)
    }

    function RenderEOC(props) {
        if (props.value.eoc_open) {
            // return (<CheckCircleIcon sx={{color: '#cd6c4a', width: "20px"}}/>)
            const start_eoc = dayjs().year(props.value.eoc.eoc_open_year).week(props.value.eoc.eoc_open_week).day(0).format("ww/BBBB")
            const end_eoc = props.value.eoc?.closed_eoc_year ? dayjs().year(props.value.eoc.closed_eoc_year).week(props.value.eoc.closed_eoc_week).day(0).format("ww/BBBB") : "ปัจจุบัน"
            const tText = `EOC ระหว่าง ${start_eoc} - ${end_eoc}`

            return (<Tooltip title={tText} onClick={handleEOCDetailOpen}><Button value={props.value.eoc.eoc_id} className='bg-[#cd6c4a] hover:bg-[#cd6c4a] w-full h-4' /></Tooltip>)
        }

        if (props.value.wo_eoc) {
            return (<Tooltip title={`${props.value.wo_eoc} กิจกรรม`}><div className='bg-[#6cad65] hover:bg-[#6cad65] w-full h-4 text-center text-white text-[12px]'>{`${props.value.wo_eoc > 1 ? props.value.wo_eoc : ""}`}</div></Tooltip>)
        }
    }

    useEffect(() => {
        let level = 1;
        let eoc_level = "02";
        if (areaLevel === "region") {
            level = 1;
            eoc_level = "02";
        } else if (areaLevel === "province") {
            level = 2;
            eoc_level = "03";
        } else if (areaLevel === "amphur") {
            level = 3;
            eoc_level = "04";
        } else if (areaLevel === "tambon") {
            level = 4;
            eoc_level = "05";
        }
        else eoc_level = "01";

        setEOCLevel(eoc_level);
        const initColumn = () => {
            let tmpColumn = [];
            let pinColumn = []
            pinColumn.push('health_region_name');
            tmpColumn.push({ field: 'health_region_name', headerName: 'สคร.', width: 200 });
            if (level > 1) {
                pinColumn.push('prov_namt');
                tmpColumn.push({
                    field: 'prov_namt',
                    headerName: 'จังหวัด',
                    width: 160,
                });
                if (level > 2) {
                    pinColumn.push('amp_namt');
                    tmpColumn.push({ field: 'amp_namt', headerName: 'อำเภอ', width: 160 });
                    if (level > 3) {
                        pinColumn.push('tambon_namt');
                        tmpColumn.push({ field: 'tambon_namt', headerName: 'ตำบล', width: 160 });
                    }
                }
            }

            let columnGroup = {}
            for (let idx in weeklist) {
                const element = weeklist[idx];
                const yearMonth = dayjs().year(element.year).week(element.week).day(0)
                const yearMonthGroup = yearMonth.format("YYYY-MM")
                if (columnGroup[yearMonthGroup]) {
                    columnGroup[yearMonthGroup].children.push({ field: `${element.year}-${element.week}` })
                }
                else {
                    columnGroup[yearMonthGroup] = {
                        groupId: yearMonthGroup,
                        headerName: yearMonth.format("MMM BBBB"),
                        description: '',
                        children: [{ field: `${element.year}-${element.week}` }],
                    }
                }

                tmpColumn.push({
                    field: `${element.year}-${element.week}`,
                    headerName: `${element.week}`,
                    width: 50,
                    type: 'boolean',
                    sortable: false,
                    cellClassName: (params) => {
                        if (params.value.eoc_qualify) {
                            return 'eoc_qualify week_cell';
                        }

                        return 'not_eoc_qualify week_cell'
                    },
                    renderCell: (params) => <RenderEOC {...params} />
                });
            }


            // console.log(currentWeek);
            setColumns(tmpColumn);
            setPinColumns(pinColumn);

            setColumnGrouping(Object.keys(columnGroup).map((key) => { return columnGroup[key] }))
        }

        const callData = async () => {
            iaam.getAccessToken(async (err, access_token) => {
                if (!err) {
                    setIsLoading(true);
                    // get the data from the api
                    let options = {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `bearer ${access_token}`
                        }
                    }
                    const year = weeklist[weeklist.length - 1].year;
                    const response = await fetch(`${process.env.REACT_APP_API_URL_SECURE}/d506-eoc/list${areaLevel}?year=${year}&disease_class=1`, options);
                    const json = await response.json();

                    // get EOC is Opening
                    const cond = areaSelected.level > 1 ? `&area_code=${areaSelected.value}` : ""
                    const resp = await fetch(`${process.env.REACT_APP_API_URL}/monitor/get_eoc_timeline?eoc_level=${eoc_level}&week=${woy.week}&year=${woy.year}${cond}`, options);
                    const eoc_open = await resp.json();


                    eoc_open.forEach((eoc) => {

                        if (eoc_level === "02") {
                            if (!json[eoc.health_region_code]?.open_eoc) {
                                json[eoc.health_region_code] = { ...json[eoc.health_region_code], open_eoc: [] }
                            }
                            if (json[eoc.health_region_code]) {
                                json[eoc.health_region_code].open_eoc.push({ eoc_id: eoc.eoc_id, eoc_open_status: true, eoc_open_ts: eoc.create_timestamp, eoc_open_week: eoc.start_eoc_week, eoc_open_year: eoc.start_eoc_year, closed_eoc_week: eoc?.closed_eoc_week, closed_eoc_year: eoc?.closed_eoc_year })
                            }
                        }
                        else {
                            if (json[eoc.area_code]) {
                                if (!json[eoc.area_code]?.open_eoc) {
                                    json[eoc.area_code] = { ...json[eoc.area_code], open_eoc: [] }
                                }
                                json[eoc.area_code].open_eoc.push({ eoc_id: eoc.eoc_id, eoc_open_status: true, eoc_open_ts: eoc.create_timestamp, eoc_open_week: eoc.start_eoc_week, eoc_open_year: eoc.start_eoc_year, closed_eoc_week: eoc?.closed_eoc_week, closed_eoc_year: eoc?.closed_eoc_year })
                            }
                        }
                    })

                    const wo_eoc_res = await fetch(`${process.env.REACT_APP_API_URL}/monitor/get_activity_wo_eoc_timeline?eoc_level=${eoc_level}&week=${woy.week}&year=${woy.year}${cond}`, options);
                    const wo_eoc = await wo_eoc_res.json();
                    // console.log(wo_eoc)
                    wo_eoc.forEach((activity) => {

                        if (eoc_level === "02") {
                            if (!json[activity.health_region_code]?.open_eoc) {
                                json[activity.health_region_code] = { ...json[activity.health_region_code], wo_eoc: [] }
                            }

                            if (json[activity.health_region_code]) {
                                json[activity.health_region_code].wo_eoc.push(activity)
                            }
                        }
                        else {
                            if (json[activity.area_code]) {
                                if (!json[activity.area_code]?.wo_eoc) {
                                    json[activity.area_code] = { ...json[activity.area_code], wo_eoc: [] }
                                }
                                json[activity.area_code].wo_eoc.push(activity)
                            }
                        }
                    })

                    let tmpData = [];
                    let keys = Object.keys(json);
                    for (let index = 0; index < keys.length; index++) {
                        const key = keys[index];
                        let eocData = json[key]
                        // console.log(eocData)
                        let regionData = regionMap[eocData.region_code];
                        let provinceData = {};
                        let amphurData = {};
                        let tambonData = {};
                        if (level > 1) {
                            provinceData = provinceMap[eocData.province_code];
                            if (level > 2) {
                                amphurData = amphurMap[eocData.amphur_code];
                                if (level > 3) {
                                    tambonData = tambonMap[eocData.tambon_code];
                                }
                            }
                        }
                        let eocWeek = {};
                        const eocWeekStatus = eocData.eoc;
                        for (let index = 0; index < weeklist.length; index++) {
                            const element = weeklist[index];
                            let eocQualify = eocWeekStatus.indexOf(`${element.year}-${element.week}`) !== -1;
                            const eoc_open = eocData?.open_eoc ? isBetweenOpenEOC(eocData.open_eoc, element.week, element.year) : {}
                            // console.log(eocData?.wo_eoc)
                            const wo_eoc = eocData?.wo_eoc ? getWoEoc(eocData.wo_eoc, element.week, element.year) : 0
                            // console.log(wo_eoc)
                            eocWeek[`${element.year}-${element.week}`] = {
                                eoc_qualify: eocQualify,
                                eoc_open: eoc_open?.status,
                                eoc: eoc_open?.eocData,
                                wo_eoc: wo_eoc
                            };
                        }
                        // console.log(regionData);
                        const data = {
                            ...regionData,
                            ...provinceData,
                            ...amphurData,
                            ...tambonData,
                            ...eocWeek
                        }
                        // console.log(data);
                        tmpData.push(data);
                    }
                    const rows = tmpData.map((row, index) => { return { ...row, id: index } })
                    setDataTable(rows);
                    setIsLoading(false);

                }
                else {
                    iaam.login()
                }
            })

        }
        // console.log(weeklist);
        // console.log(areaLevel);
        if (weeklist.length !== 0 && Object.keys(tambonMap).length !== 0) {
            initColumn();
            callData();
        }
    }, [areaLevel, weeklist, regionMap, provinceMap, amphurMap, tambonMap])

    useEffect(() => {
        const filterData = async () => {
            if (areaSelected.level === 1) {
                setDataTableShow([...dataTable]);
            } else {
                setIsLoading(true);
                let tmpData = [];
                let provinceList = [];
                if (areaSelected.level === 2) {
                    const response = await fetch(`${process.env.REACT_APP_MASTER_API_URL}/area/province?dpc_code=${areaSelected.value}`);
                    provinceList = await response.json();
                }
                for (let index = 0; index < dataTable.length; index++) {
                    const element = dataTable[index];
                    if (areaSelected.level === 2) {
                        let searchIndex = provinceList.findIndex(({ prov_code }) => prov_code === element.prov_code);
                        if (searchIndex !== -1) {
                            tmpData.push(element);
                        }
                    } else if (areaSelected.level === 3) {
                        if (element.prov_code === areaSelected.value) {
                            tmpData.push(element);
                        }
                    } else if (areaSelected.level === 4) {
                        if (element.amp_code === areaSelected.value) {
                            tmpData.push(element);
                        }
                    } else if (areaSelected.level === 5) {
                        if (element.tambon_code === areaSelected.value) {
                            tmpData.push(element);
                        }
                    }
                }
                const rows = tmpData.map((row, index) => { return { ...row, id: index } })
                setDataTableShow(rows);
                setIsLoading(false);
            }
            setCoordinates({ ...coordinates, colIndex: columns.length - 1 })
        }
        if (dataTable.length !== 0) {
            filterData();
        }
    }, [dataTable, areaSelected])

    React.useEffect(() => {

        refTable.current.scrollToIndexes(coordinates);

    }, [refTable, coordinates]);

    function CustomToolbar(props) {
        return (
            <GridToolbarContainer className="flex m-2 justify-between item-center">
                <GridToolbarQuickFilter variant="outlined" size="small" />
                <div className='flex md:justify-end items-end gap-2'>
                    <IconButton onClick={() => setOpenLegend(true)} >
                        <InfoIcon />
                    </IconButton>
                    <div className='min-w-[120px] flex gap-2 py-[6px] content-start'>
                        <div className='w-6 h-4 bg-[#1150A4]'></div>
                        <Typography variant='body2' sx={{
                            color: "#1150A4"
                        }}>
                            เข้าเกณฑ์เปิด EOC
                        </Typography>
                    </div>
                    <div className='min-w-[120px] flex gap-2 py-[6px] px-3 content-start'>
                        <div className='w-6 h-4 bg-[#cd6c4a]'></div>
                        <Typography variant='body2' sx={{
                            color: "#cd6c4a"
                        }}>
                            เปิด EOC
                        </Typography>
                    </div>
                    <div className='min-w-[120px] flex gap-2 py-[6px] px-3 content-start'>
                        <div className='w-6 h-4 bg-[#6cad65]'></div>
                        <Typography variant='body2' sx={{
                            color: "#6cad65"
                        }}>
                            กิจกรรมตอบโต้
                        </Typography>
                    </div>
                </div>
            </GridToolbarContainer>
        );
    }

    return (
        <div className='h-full w-full overflow-hidden'>
            <DengueEOCLegeng  open={openLegend} eoc_level={eocLevel} onClose={() => setOpenLegend(!openLegend)}/>
            <StyledDataGrid
                apiRef={refTable}
                experimentalFeatures={{ columnGrouping: true }}
                hideFooter
                density="compact"
                rows={dataTableShow}
                columns={columns}
                disableColumnMenu
                loading={isLoading}
                slots={{ toolbar: CustomToolbar, loadingOverlay: LinearProgress }}
                pinnedColumns={{
                    left: pinColumns
                }}
                columnGroupingModel={columnGrouping}
                autosizeOnMount
                autosizeOptions={autoSizeOptions}
            />
            <EOCDetailDialog open={openDialog} setOpen={setOpenDialog} eoc_id={eocId} />
        </div>
    )
}

export default MonitorTimeline
